module.exports = __webpack_public_path__ + "static/media/Discovery-Scale.5a8fbca4.svg";